module.exports = __webpack_public_path__ + "img/serve1.f80d083f.png";